import { REHYDRATE } from "redux-persist";
import {
    WECHAT_LOGIN_BEGIN,
    WECHAT_LOGIN_SUCCESS,
    WECHAT_LOGIN_FAIL,
} from "actions/wechatLoginActions";
import { LOGOUT } from "actions/loginStateActions";
import { setCookie } from "../util/icwUtility";

export default function(state = { profile: null, status: "uninitialized" }, action) {
    switch (action.type) {
        case REHYDRATE: {
            if (action.payload != null && action.payload.loginState != null)
                return action.payload.loginState;
            return state;
        }
        case WECHAT_LOGIN_BEGIN:
            return { status: "loginInProgress" };

        case WECHAT_LOGIN_SUCCESS:
            setCookie("wechatToken", action.res.data.token);
            return { status: "ready" };

        case WECHAT_LOGIN_FAIL:
            return {
                status: "failed",
                failReason: action.reason.message,
            };

        case LOGOUT:
            setCookie("wechatToken", "");
            return state;

        default:
            return state;
    }
}
